import React from 'react'
import Sponsor from '../img/sponsor-1.jpg'
import Sponsor2 from '../img/sponsor-2.jpg'


export class Sponsors extends React.PureComponent {
    render() {


        return (
            <div className="container my-5 w-100">
                <h5 className="text-center py-3">Sponsored by</h5>
                <div className="d-flex flex-row align-items-center justify-content-center flex-wrap">
                    <div className="sponsorImages">
                        <a href="https://www.instagram.com/barbershop.omen/" target="_blank" rel="noopener noreferrer">
                            <img src={Sponsor} className="rounded" alt="Barber Shop Omen"></img>
                        </a>
                    </div>


                    <div className="sponsorImages">
                        <a href="https://www.instagram.com/abraxas3600/" target="_blank" rel="noopener noreferrer">
                            <img src={Sponsor2} className="rounded" alt="Abraxas"></img>
                        </a>
                    </div>



                </div>

                   

            </div>
        )
    }
}
export default React.memo(Sponsors)
